module.exports = __webpack_public_path__ + "static/img/data3-img.577dd965.png";